import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import IndicationBar from '../../components/IndicationBar/IndicationBar'
import ModelSelection from '../../components/ModelSelection/ModelSelection'
import SelectedModels from '../../components/SelectedModels/SelectedModels'
import { MainContainer, MiddleBorder, Wrapper } from './Calculator.styles'
import { useGetBrands, useGetProducts } from '../../hooks/api'
import Toast, { ToastIntentEnum } from '../../components/Toast/Toast'
import { Product } from '../../services/types/product'
import { useGetConfigs } from '../../hooks/useGetConfigs'
// import useLocalStorage from '../../hooks/useLocalStorage'

const Calculator: React.FC = () => {
  const location = useLocation()
  const { brandId: brandIdFromLocation } = location.state || {}
  const name = useParams<{ name: string }>().name
  const [skipToken, setSkipToken] = React.useState<string | undefined>(
    undefined
  )

  const [brandId, setBrandId] = React.useState<string>(brandIdFromLocation)

  const { data: brands } = useGetBrands()

  const { configs } = useGetConfigs()

  const { SURVEY_QUESTION, JOB_SITE_CAPACITY } = configs || {
    SURVEY_QUESTION: '',
    JOB_SITE_CAPACITY: 0
  }

  const { isPending, isError, error, data, isFetching, isPlaceholderData } =
    useGetProducts({
      brandId: brandId || '',
      skipToken
    })

  const [selectedProducts, setSelectedProducts] = useState<Product[]>([])

  // TO-ACTIVATE
  // To avoid mix and match of selected products between brands, we need to store the selected products per brand
  // const storageKey = brandId
  //   ? `selectedProducts_${brandId}`
  //   : 'selectedProducts'
  //
  // const [selectedProducts, setSelectedProducts] = useLocalStorage<Product[]>(
  //   storageKey,
  //   []
  // )

  useEffect(() => {
    // get the brand id from the name
    const brandIdFromName =
      brands?.find((brand) => brand.name === name)?.id || ''
    setBrandId(brandIdFromName)
  }, [brands, name])

  if (isError) {
    return (
      <Toast
        triggerToast={ToastIntentEnum.Error}
        title={error.message || 'There was an error getting the data'}
      />
    )
  }

  return (
    <Wrapper>
      <IndicationBar brandName={name || ''} surveyQuestion={SURVEY_QUESTION} />
      <MainContainer>
        <ModelSelection
          setSkipToken={setSkipToken}
          brandId={brandId}
          selectedProducts={selectedProducts}
          setSelectedProducts={setSelectedProducts}
          isLoading={isPending}
          initialData={data || { products: [], nextSkipToken: '' }}
          isFetching={isFetching}
          isPlaceholderData={isPlaceholderData}
        />
        <MiddleBorder />
        <SelectedModels
          selectedProducts={selectedProducts}
          setSelectedProducts={setSelectedProducts}
          jobSiteCapacity={JOB_SITE_CAPACITY}
        />
      </MainContainer>
    </Wrapper>
  )
}

export default Calculator
